module.exports = __webpack_public_path__ + "static/media/2-option7-4row.9fd6f32d.png";